/**
 * Created by coolguy on 2018/8/30.
 */
import request from '../utils/request';
import { IResult } from '../global';

const comment = {
  //删除
  del: (id: number) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/comment/destroy',
        method: 'post',
        data: { id },
        headers: {
          Authorization: request.token
        }
      })
        .then((jsonData: any) => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  post: ({ content = '', galleryid = '' }) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/comment/post',
        method: 'post',
        data: { content, galleryid },
        headers: {
          Authorization: request.token
        }
      })
        .then((jsonData: any) => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  list: (galleryid = '', id = '', time = 0) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/comment/list',
        data: { galleryid, time, pagesize: 50 }
      })
        .then((res: any) => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  top: (galleryid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/comment/gallery/top',
        data: {
          galleryid
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  my: (galleryid: string) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/comment/my',
        data: { galleryid },
        headers: {
          Authorization: request.token
        }
      })
        .then((res: any) => {
          resolve(res);
        })
        .catch(reject);
    });
  }
};

export default comment;
